import BusDirectoryMapContainer from '../../../../components/containers/BusDirectoryMapContainer';
import preloadCustomProps from '../../../utils/preloads/preloadBusDirectoryMap';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'bus-directory-map',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: BusDirectoryMapContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
